import { usePopups } from './usePopups';

export const useHasActivePopups = () => {
  const { popups } = usePopups();
  return !!popups?.some((popup) => popup.enabled);
};
